import { supabase } from '@/integrations/supabase/client';
import { agendaUuid } from '@/lib/agendaExecutor';

export interface AgendaContextHandoff {
  user_id: string; handoff_id: string;
  title: string; notes: string | null; tag: 'Meeting'; source: 'manual';
}
const pending = new Map<string, { value: AgendaContextHandoff; expires: number }>();
let owner: string | null = null;
let subscribed = false;
/** Private email data crosses navigation only through an owned, one-use memory capability. */
export function createAgendaContextHandoff(input: { title: string; notes: string | null }, userId: string): AgendaContextHandoff | null {
  if (!agendaUuid(userId) || typeof input.title !== 'string' || !input.title.trim() || input.title.length > 1000 || input.title.includes('\0') ||
    (input.notes !== null && (typeof input.notes !== 'string' || input.notes.length > 8000 || input.notes.includes('\0')))) return null;
  if (!subscribed) {
    owner = userId; subscribed = true;
    supabase.auth.onAuthStateChange((_event, session) => {
      const next = session?.user.id ?? null;
      if (next !== owner) pending.clear();
      owner = next;
    });
  }
  if (owner !== userId) return null;
  const now = Date.now();
  for (const [key, entry] of pending) if (entry.expires <= now) pending.delete(key);
  while (pending.size >= 20) pending.delete(pending.keys().next().value!);
  const value: AgendaContextHandoff = { ...input, user_id: userId, handoff_id: crypto.randomUUID(), tag: 'Meeting', source: 'manual' };
  pending.set(value.handoff_id, { value: { ...value }, expires: now + 600_000 });
  return value;
}
export function takeOwnedAgendaContext(input: unknown, userId: string | null): AgendaContextHandoff | null {
  if (!userId || owner !== userId || !input || typeof input !== 'object' || Array.isArray(input)) return null;
  const raw = input as Record<string, unknown>;
  if (!agendaUuid(raw.handoff_id)) return null;
  const entry = pending.get(raw.handoff_id); pending.delete(raw.handoff_id);
  if (!entry || entry.expires <= Date.now() || entry.value.user_id !== userId || Object.keys(raw).length !== 6 ||
    Object.keys(entry.value).some(key => raw[key] !== entry.value[key as keyof AgendaContextHandoff])) return null;
  return { ...entry.value };
}
